export { PopupGuard } from './popup.guard';



// WEBPACK FOOTER //
// ./src/app/guards/index.ts